import React, { FC } from "react";
import "./AmountChooser.module.scss";
import { Minus, Plus } from "phosphor-react";
import PropTypes from "prop-types";

function filterByNumbers(str) {
	return (str.match(/\d+/g) || []).join("");
}

function getAmountFromCurrencyString(currencyString) {
	let rawAmount = filterByNumbers(currencyString);
	const formattedAmount = Number(rawAmount) / 100;

	return formattedAmount;
}

// export interface AmountChooserProps {
// 	minAmount?: number;
// 	maxAmount?: number;
// 	incrementAmount?: number;
// 	decrementAmount?: number;
// 	currentAmount: number;
// 	allowManualChange?: boolean;
// 	formatter?: (amount: number) => string | number;
// 	onSetIncrement?: (newAmount: number) => void;
// 	onSetDecrement?: (newAmount: number) => void;
// 	onExceedIncrement?: (invalidAmount: number, exceededBy: number) => void;
// 	onExceedDecrement?: (invalidAmount: number, exceededBy: number) => void;
// 	maxWidth?: number;
// 	// onValidManualChange?: (newAmount: number) => void;
// }

export const realCurrencyFormatter = (amount) => {
	const brlFormatter = Intl.NumberFormat("pt-BR", {
		style: "currency",
		currency: "BRL",
	});
	return brlFormatter.format(amount);
};

export const AmountChooser = ({
	currentAmount,
	minAmount = 0,
	maxAmount = Infinity,
	allowManualChange = true,
	formatter = realCurrencyFormatter,
	incrementAmount = 1,
	decrementAmount = 1,
	onSetIncrement,
	onSetDecrement,
	onExceedIncrement,
	onExceedDecrement,
	onManualChange,
	onManualLeave,
	maxWidth,
	className
}) => {
	const amountHandlers = {
		increment() {
			const newAmount = currentAmount + incrementAmount;
			if (newAmount > maxAmount) {
				onExceedIncrement && onExceedIncrement(newAmount, newAmount - maxAmount);
				return;
			}
			if (newAmount < minAmount) {
				onExceedDecrement && onExceedDecrement(newAmount, Math.abs(newAmount + minAmount));
				return;
			}
			onSetIncrement && onSetIncrement(newAmount);
		},
		decrement() {
			const newAmount = currentAmount - decrementAmount;
			if (newAmount < minAmount){
				onExceedDecrement && onExceedDecrement(
					newAmount,
					Math.abs(newAmount + minAmount),
				);
				return;
			}

			if (newAmount > maxAmount) {
				onExceedIncrement && onExceedIncrement(newAmount, newAmount - maxAmount);
			}

			onSetDecrement && onSetDecrement(newAmount);
		},
		manualChange(e) {
			// When typing in the input, updates de current amount
			e.preventDefault();
			if (!allowManualChange || !e.isTrusted) return;

			const target = e.currentTarget;
			const digitCheck = target.value.match(/[^0-9]/g);
			if(digitCheck && digitCheck.length > 0) return;
			if(onManualChange) onManualChange(target.value);
		},
		manualInputLeave(e) {
			// When leaving the input, it validates the changed value
			const target = e.currentTarget;
			// const inputValue = getAmountFromCurrencyString(target.value);
			if(onManualLeave) onManualLeave(target.value);
		},
		arrowChange(e){
			if(e.key === "ArrowUp") {
				e.preventDefault();
				return this.increment()
			} else if (e.key === "ArrowDown") {
				e.preventDefault();
				return this.decrement();
			}
		}
	};

	return (
		<React.Fragment>
			<div className={`amountChooser__amountChooser ${className}`} style={{ maxWidth }}>
				<div className={"amountChooser__borderBack"} />
				<button
					onClick={amountHandlers.decrement}
					className="amountChooser__button"
				><Minus /></button>
				<input
					type="text"
					className={"amountChooser__amountInput"}
					value={formatter ? formatter(currentAmount) : currentAmount}
					onKeyDown={amountHandlers.arrowChange.bind(amountHandlers)}
					onChange={amountHandlers.manualChange}
					onBlur={amountHandlers.manualInputLeave}
				/>
				<button
					onClick={amountHandlers.increment}
					className="amountChooser__button"
				><Plus /></button>
			</div>
		</React.Fragment>
	);
};

AmountChooser.propTypes = {
	currentAmount: PropTypes.number.isRequired,
	minAmount: PropTypes.number,
	maxAmount: PropTypes.number,
	incrementAmount: PropTypes.number,
	decrementAmount: PropTypes.number,
	allowManualChange: PropTypes.bool,
	formatter: PropTypes.func,
	onSetIncrement: PropTypes.func,
	onSetDecrement: PropTypes.func,
	onExceedIncrement: PropTypes.func,
	onExceedDecrement: PropTypes.func,
	onManualChange: PropTypes.func,
	onManualLeave: PropTypes.func,
	maxWidth: PropTypes.number,
	className: PropTypes.string,
  };


// WEBPACK FOOTER //
// ./src/rifa/components/layout/amountchooser/AmountChooser.jsx